export const dummyData = [
    {
        "projectGuid": "XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
        "clientDashboardFeedId": 4789,
        "jobTitleGuid": "XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
        "employeeGuid": "XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
        "documentId": null,
        "eventCategoryTypeId": 11,
        "eventDescription": "The ocean sunfish (Mola mola), is one of the largest bony fish in the world.",
        "isActive": true,
        "createdDate": "2025-02-07T15:10:14.143Z",
        "createdBy": 1027,
        "notificationDetails": [
            {
                "@odata.type": "#ProScore.Api.Application.Clients.Models.ApprenticeAddedFeedDetailDto",
                "apprenticeAddedFeedDetailId": 1,
                "firstname": "Steve",
                "lastname": "Erwin",
                "projectName": "Nat Geo",
                "createdDate": "2025-02-07T15:10:14.563Z",
                "is671Complete": false,
                "is90DayCertificateValid": false,
                "isRapidsRegistrationComplete": false,
                "clientDashboardFeedId": 4789
            }
        ]
    },
    {
        "projectGuid": "XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
        "clientDashboardFeedId": 4789,
        "jobTitleGuid": "XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
        "employeeGuid": "XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
        "documentId": null,
        "eventCategoryTypeId": 11,
        "eventDescription": "The ocean sunfish (Mola mola), is one of the largest bony fish in the world.",
        "isActive": true,
        "createdDate": "2025-02-07T15:10:14.143Z",
        "createdBy": 1027,
        "notificationDetails": [
            {
                "@odata.type": "#ProScore.Api.Application.Clients.Models.ApprenticeAddedFeedDetailDto",
                "apprenticeAddedFeedDetailId": 1,
                "firstname": "Steve",
                "lastname": "Erwin",
                "projectName": "Nat Geo",
                "createdDate": "2025-02-07T15:10:14.563Z",
                "is671Complete": false,
                "is90DayCertificateValid": false,
                "isRapidsRegistrationComplete": false,
                "clientDashboardFeedId": 4789
            }
        ]
    },
    {
        "projectGuid": "XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
        "clientDashboardFeedId": 4789,
        "jobTitleGuid": "XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
        "employeeGuid": "XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
        "documentId": null,
        "eventCategoryTypeId": 11,
        "eventDescription": "The ocean sunfish (Mola mola), is one of the largest bony fish in the world.",
        "isActive": true,
        "createdDate": "2025-02-07T15:10:14.143Z",
        "createdBy": 1027,
        "notificationDetails": [
            {
                "@odata.type": "#ProScore.Api.Application.Clients.Models.ApprenticeAddedFeedDetailDto",
                "apprenticeAddedFeedDetailId": 1,
                "firstname": "Steve",
                "lastname": "Erwin",
                "projectName": "Nat Geo",
                "createdDate": "2025-02-07T15:10:14.563Z",
                "is671Complete": false,
                "is90DayCertificateValid": false,
                "isRapidsRegistrationComplete": false,
                "clientDashboardFeedId": 4789
            }
        ]
    },
    {
        "projectGuid": "XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
        "clientDashboardFeedId": 4789,
        "jobTitleGuid": "XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
        "employeeGuid": "XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
        "documentId": null,
        "eventCategoryTypeId": 11,
        "eventDescription": "The ocean sunfish (Mola mola), is one of the largest bony fish in the world.",
        "isActive": true,
        "createdDate": "2025-02-07T15:10:14.143Z",
        "createdBy": 1027,
        "notificationDetails": [
            {
                "@odata.type": "#ProScore.Api.Application.Clients.Models.ApprenticeAddedFeedDetailDto",
                "apprenticeAddedFeedDetailId": 1,
                "firstname": "Steve",
                "lastname": "Erwin",
                "projectName": "Nat Geo",
                "createdDate": "2025-02-07T15:10:14.563Z",
                "is671Complete": false,
                "is90DayCertificateValid": false,
                "isRapidsRegistrationComplete": false,
                "clientDashboardFeedId": 4789
            }
        ]
    },
    {
        "projectGuid": "XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
        "clientDashboardFeedId": 4789,
        "jobTitleGuid": "XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
        "employeeGuid": "XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
        "documentId": null,
        "eventCategoryTypeId": 11,
        "eventDescription": "The ocean sunfish (Mola mola), is one of the largest bony fish in the world.",
        "isActive": true,
        "createdDate": "2025-02-07T15:10:14.143Z",
        "createdBy": 1027,
        "notificationDetails": [
            {
                "@odata.type": "#ProScore.Api.Application.Clients.Models.ApprenticeAddedFeedDetailDto",
                "apprenticeAddedFeedDetailId": 1,
                "firstname": "Steve",
                "lastname": "Erwin",
                "projectName": "Nat Geo",
                "createdDate": "2025-02-07T15:10:14.563Z",
                "is671Complete": false,
                "is90DayCertificateValid": false,
                "isRapidsRegistrationComplete": false,
                "clientDashboardFeedId": 4789
            }
        ]
    },
    {
        "projectGuid": "XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
        "clientDashboardFeedId": 4789,
        "jobTitleGuid": "XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
        "employeeGuid": "XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
        "documentId": null,
        "eventCategoryTypeId": 11,
        "eventDescription": "The ocean sunfish (Mola mola), is one of the largest bony fish in the world.",
        "isActive": true,
        "createdDate": "2025-02-07T15:10:14.143Z",
        "createdBy": 1027,
        "notificationDetails": [
            {
                "@odata.type": "#ProScore.Api.Application.Clients.Models.ApprenticeAddedFeedDetailDto",
                "apprenticeAddedFeedDetailId": 1,
                "firstname": "Steve",
                "lastname": "Erwin",
                "projectName": "Nat Geo",
                "createdDate": "2025-02-07T15:10:14.563Z",
                "is671Complete": false,
                "is90DayCertificateValid": false,
                "isRapidsRegistrationComplete": false,
                "clientDashboardFeedId": 4789
            }
        ]
    },
    {
        "projectGuid": "XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
        "clientDashboardFeedId": 4789,
        "jobTitleGuid": "XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
        "employeeGuid": "XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
        "documentId": null,
        "eventCategoryTypeId": 11,
        "eventDescription": "The ocean sunfish (Mola mola), is one of the largest bony fish in the world.",
        "isActive": true,
        "createdDate": "2025-02-07T15:10:14.143Z",
        "createdBy": 1027,
        "notificationDetails": [
            {
                "@odata.type": "#ProScore.Api.Application.Clients.Models.ApprenticeAddedFeedDetailDto",
                "apprenticeAddedFeedDetailId": 1,
                "firstname": "Steve",
                "lastname": "Erwin",
                "projectName": "Nat Geo",
                "createdDate": "2025-02-07T15:10:14.563Z",
                "is671Complete": false,
                "is90DayCertificateValid": false,
                "isRapidsRegistrationComplete": false,
                "clientDashboardFeedId": 4789
            }
        ]
    },
    {
        "projectGuid": "XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
        "clientDashboardFeedId": 4789,
        "jobTitleGuid": "XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
        "employeeGuid": "XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
        "documentId": null,
        "eventCategoryTypeId": 11,
        "eventDescription": "The ocean sunfish (Mola mola), is one of the largest bony fish in the world.",
        "isActive": true,
        "createdDate": "2025-02-07T15:10:14.143Z",
        "createdBy": 1027,
        "notificationDetails": [
            {
                "@odata.type": "#ProScore.Api.Application.Clients.Models.ApprenticeAddedFeedDetailDto",
                "apprenticeAddedFeedDetailId": 1,
                "firstname": "Steve",
                "lastname": "Erwin",
                "projectName": "Nat Geo",
                "createdDate": "2025-02-07T15:10:14.563Z",
                "is671Complete": false,
                "is90DayCertificateValid": false,
                "isRapidsRegistrationComplete": false,
                "clientDashboardFeedId": 4789
            }
        ]
    }
];